import {FilterMatchMode} from 'primevue/api';
import Pageable from '@/models/dto/filters/Pageable';

export default class LineIdFilter extends Pageable {
  /**
   * Filtre des attributions de fréquences
   * @param {Pageable} pageable la pagination
   * @param {Boolean} associated true si on veut les attributions associées, false sinon
   * @param {Number} stakeholder id du stakeholder
   * @param {String} stakeholderId l'identifiant du stakeholder
   * @param {String} spectrumService type d'équipement
   * @param {Number} barcodeRangeId id de la plage de code-barres
   * @param {FilterMatchMode} barcodeRangeIdMatcher mode de comparaison de la plage de code-barres
   * @param {String[]} mainVenues
   * @param {String[]}licencePeriods
   * @param {Date} startDate
   * @param {Date} endDate
   * @param {Number} tuningRangeFrom
   * @param {Number} tuningRangeTo
   * @param {String} duplexHigh
   * @param {String} duplexLow
   */
  constructor({
                pageable,
                associated = null,
                stakeholder = null,
                stakeholderId = null,
                spectrumService = null,
                barcodeRangeId = null,
                barcodeRangeIdMatcher = null,
                mainVenues = null,
                licencePeriods = null,
                spectrumServices = null,
                startDate = null,
                endDate = null,
                tuningRangeFrom = null,
                tuningRangeTo = null,
                duplexHigh = null,
                duplexLow = null,
              }) {
    super(pageable);
    this.associated = associated;
    this.stakeholder = stakeholder;
    this.stakeholderId = stakeholderId;
    this.spectrumService = spectrumService;
    this.barcodeRangeId = barcodeRangeId;
    this.barcodeRangeIdMatcher = barcodeRangeIdMatcher;
    this.mainVenues = mainVenues;
    this.licencePeriods = licencePeriods;
    this.spectrumServices = spectrumServices;
    this.startDate = startDate;
    this.endDate = endDate;
    this.tuningRangeFrom = tuningRangeFrom;
    this.tuningRangeTo = tuningRangeTo;
    this.duplexHigh = duplexHigh;
    this.duplexLow = duplexLow;
  }
}
